import { handleBulkActionApi } from '@apis/seller-center/orders';
import { Button, Modal, Toast } from '@common-web';
import { convertQueryObjToString } from '@components-web/filters/helper';
import { RESPONSE_TYPES, SELLER_BULK_ACTION_TYPES } from '@constants/generic-constants';
import { strings } from '@constants/strings';
import { isCP } from '@utils/app-utils.js';
import { getErrorString } from '@utils/utils';
import { Checkbox, Flex } from 'antd';
import { useState } from 'react';
import { ORDER_ACTIONS_BUTTON_CONFIG } from '../../orders-constants';
import BulkActionModal from './bulk-actions-modal';

// import tenantConfig from 'data/customizer/tenant-config';

const BulkActionsDock = ({
  selectedOrders = [],
  setSelectedOrders = () => { },
  selectedLineItems = [],
  setSelectedLineItems = () => { },
  applicableOrders = [],
  possibleBulkActions = [],
  handleCPActions = () => { },
  hideSelectCheckbox = false,
}) => {
  const [confirmationModal, setConfirmationModal] = useState(null);
  const [loading, setLoading] = useState(false);

  const acceptOrders = async (action, selectedLineItems = []) => {
    const payload = {
      orders: selectedOrders?.map((order) => ({
        order: {
          id: order?.id,
          line_items: order?.line_items
            ?.filter((item) => {
              return selectedLineItems?.includes(item?.id);
            })
            ?.map((item) => ({
              id: item?.id,
              inventory: item?.inventory?.id,
            })),
        },
      })),
    };
    const extraParams = {
      url: action?.url,
      method: action?.http_method,
    };
    try {
      setLoading(true);
      const response = await handleBulkActionApi(payload, extraParams);
      setConfirmationModal(null);
      Toast.success(response?.message);
      setSelectedOrders([]);
    } catch (err) {
      Toast.error(getErrorString(err));
    } finally {
      setLoading(false);
    }
  };

  const printShippingLabel = async (action) => {
    const params = convertQueryObjToString({
      'consignment_ids[]': selectedOrders?.map((order) => order?.consignment?.id)?.join(','),
    });
    const extraParams = {
      url: `${action?.url}?${params}`,
      method: action?.http_method,
      responseType: RESPONSE_TYPES?.blob,
    };
    try {
      setLoading(true);
      const response = await handleBulkActionApi(null, extraParams);
      const pdfUrl = URL.createObjectURL(response);
      window.open(pdfUrl, '_blank');

      setSelectedOrders([]);
      setConfirmationModal(null);
    } catch (err) {
      Toast.error(getErrorString(err));
    } finally {
      setLoading(false);
    }
  };

  const handleAction = (action) => {
    switch (action?.payload_identifier) {
      case SELLER_BULK_ACTION_TYPES.LINE_ITEM_IDS:
        setConfirmationModal({
          title: action?.name,
          body: <p>{strings?.are_you_sure_accept_items}</p>,
          internalState: true,
          availableAction: action,
          action: acceptOrders,
        });
        break;
      case SELLER_BULK_ACTION_TYPES.CONSIGNMENT_IDS:
        setConfirmationModal({
          title: 'Print Shipping Label',
          body: <>Are you sure you want to print shipping labels for these orders?</>,
          availableAction: action,
          action: printShippingLabel,
        });
        break;
      default:
        return;
    }
  };

  return (
    <>
      <Modal
        ModalBody={
          <BulkActionModal
            selectedOrders={selectedOrders}
            message={confirmationModal?.body}
            selectedLineItems={selectedLineItems}
            setSelectedLineItems={setSelectedLineItems}
          />
        }
        open={!!confirmationModal}
        title={confirmationModal?.title}
        handleCancel={() => setConfirmationModal(null)}
        handleOk={() => {
          if (confirmationModal?.internalState) {
            confirmationModal?.action(confirmationModal?.availableAction, selectedLineItems);
          } else {
            confirmationModal?.action(confirmationModal?.availableAction);
          }
        }}
        okText="Confirm"
        showActions={true}
        okButtonProps={{ loading }}
      />
      <div
        style={{
          display: possibleBulkActions?.length ? 'block' : 'none',
          position: 'fixed',
          zIndex: 999,
          bottom: 20,
          width: '70%',
          background: 'white',
          color: 'black',
          left: '16.5%',
          padding: 10,
          borderRadius: '10px',
          boxShadow:
            'rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px',
        }}
      >
        <Flex justify="space-between" align="center" style={{ width: '100%' }}>
          <Flex gap={8}>
            {!hideSelectCheckbox && (
              <Checkbox
                checked={selectedOrders?.length === applicableOrders?.length}
                indeterminate={selectedOrders?.length < applicableOrders?.length}
                onClick={() => {
                  if (selectedOrders?.length < applicableOrders?.length) {
                    setSelectedOrders(applicableOrders?.map((order) => ({ ...order, key: order?.id })));
                  } else {
                    setSelectedOrders([]);
                  }
                }}
              />
            )}
            {selectedOrders?.length} Selected
          </Flex>
          <Flex gap={8}>
            {possibleBulkActions?.length
              ? possibleBulkActions?.map((action) => (
                <Button
                  key={action?.slug}
                  icon={ORDER_ACTIONS_BUTTON_CONFIG?.[action?.slug]?.icon}
                  type={ORDER_ACTIONS_BUTTON_CONFIG?.[action?.slug]?.type}
                  onClick={() => (isCP() ? handleCPActions(action) : handleAction(action))}
                >
                  {action?.name}
                </Button>
              ))
              : null}
            {/*{(selectedDispostion === 'shipment-created' || selectedDispostion === 'awaiting-rider-collection') && (*/}
            {/*  <Button type={'primary-light'} onClick={printShippingLabel}>*/}
            {/*    Print Shipping Label*/}
            {/*  </Button>*/}
            {/*)}*/}
            {/*{selectedDispostion === 'shipment-created' && (*/}
            {/*  <Button*/}
            {/*    type={'primary'}*/}
            {/*    onClick={() => {*/}
            {/*      setConfirmationModal({*/}
            {/*        title: 'Confirm Pickup',*/}
            {/*        body: <p>Are you sure you want to confirm pickup for</p>,*/}
            {/*        action: confirmPickup,*/}
            {/*      });*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    Confirm Pickup*/}
            {/*  </Button>*/}
            {/*)}*/}
            {/*{selectedDispostion === 'awaiting-seller-confirmation' && (*/}
            {/*  <Button*/}
            {/*    type={'primary'}*/}
            {/*    onClick={() => {*/}
            {/*      setConfirmationModal({*/}
            {/*        title: strings?.accept_order,*/}
            {/*        body: <p>{strings?.are_you_sure_accept_items}</p>,*/}
            {/*        internalState: true,*/}
            {/*        action: acceptOrders,*/}
            {/*      });*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    Accept Order*/}
            {/*  </Button>*/}
            {/*)}*/}
            {/* {selectedDispostion === tenantConfig?.order_statuses?.accepted_by_seller?.slug && ( */}
            {/*  <Button*/}
            {/*    type={'primary'}*/}
            {/*    onClick={() => {*/}
            {/*      setConfirmationModal({*/}
            {/*        title: 'Create Shipment',*/}
            {/*        body: <p>Are you sure you want to create shipment for</p>,*/}
            {/*        action: createShipments,*/}
            {/*      });*/}
            {/*    }}*/}
            {/*  >*/}
            {/*    Create Shipment*/}
            {/*  </Button>*/}
            {/*)}*/}
          </Flex>
        </Flex>
      </div>
    </>
  );
};

export default BulkActionsDock;
